// Central place to define the feature flag names used in Unleash and config
export const SESSION_END_ORDER_ACTION_CHANGES_FLAG_NAME =
  'session_end_order_action_changes';
export const TIMER_RESET_ON_CART_UPDATE_FLAG_NAME =
  'timer_reset_on_cart_update';
export const SUPPRESS_UPSELL_FLAG_NAME = 'suppress_upsell';
export const DO_NOT_UPSELL_IN_EXPRESS_MODE_FLAG_NAME =
  'do_not_upsell_in_express_mode';
export const UNRESOLVED_ITEMS_FLAG_NAME = 'unresolved_items';
export const HITL_3_0_FLAG_NAME = 'hitl_3_0';
export const AGENT_CART_FLAG_NAME = 'agent_cart';
export const HITL_EXPRESS_TIMER_FLAG_NAME = 'hitl_express_timer';
// Carries a variant whose payload value is the agent response-time SLA in
// seconds (Pulse "Response time" tile). Falls back to the default below when the
// flag/variant is absent, so behaviour matches the previous env-var default.
export const AGENT_RESPONSE_TIME_FLAG_NAME = 'agent_response_time';
export const DEFAULT_AGENT_RESPONSE_TIME_LIMIT_SECONDS = 6;
export const MENU_MODULE_ERROR_UI_FLAG_NAME = 'menu_module_error_ui';
// Offer a Retry button when POSMON has not returned the check event for a
// non-final order within the timeout (the order progress bar stays stuck below
// green until a check arrives). Carries a variant whose payload value is the
// timeout in seconds; the default below applies when the flag/variant carries
// no payload.
export const ORDER_CHECK_RETRY_FLAG_NAME = 'order_check_retry';
export const DEFAULT_ORDER_CHECK_TIMEOUT_SECONDS = 10;
// Hide the POSLINK 7002 "Send Order is Pending" order_status error from agents
// and treat the order as still in progress: POSLINK drops the colliding
// request, but a follow-up send (usually <1s later) or the queued final order
// carries the full cart, so nothing is wrong with the items themselves
// (HITL-1417). Non-final orders only — the progress bar stays not-green and
// the order_check_retry banner still covers orders whose check never arrives.
export const MASK_ORDER_PENDING_ERROR_FLAG_NAME = 'mask_order_pending_error';
// Gates the whole secondary-ASR path: with this on, customer transcript lines
// are sourced from `asr_promoted_text` events instead of `text`/`final` frames,
// and the promoted icon is read off each event's own `metadata.source`. This is
// the AI-side flag (the secondary engine is running at all) — HITL-1497 removed
// the separate HITL-side opt-in, so one flag now governs both sides.
export const SECONDARY_ASR_ENABLED_FLAG_NAME = 'secondary_asr_enabled';
// Gates the whole in-screen issue-reporting path (HITL-1492 Pillar 3, Part A).
// ANDed with hitl_3_0 in selectIsIssueReportingEnabled, because the bottom action
// bar the button lives in only exists in MainPageLayout (Body/index.tsx) — but kept
// a separate flag so it is killable without killing HITL 3.0.
//
// ON/OFF ONLY — no variant payload is read. The taxonomy is hardcoded in
// src/constants/issueTypes.ts (HITL-1501).
export const ISSUE_REPORTING_FLAG_NAME = 'hitl_issue_reporting';
